import en from 'vuetify/es5/locale/en';
import ru from 'vuetify/es5/locale/ru';
import zh from 'vuetify/es5/locale/zh-Hans';
import et from 'vuetify/es5/locale/et';

const locales = {
  en, ru, zh, et,
};

export default locales;
